(function() {
    'use strict';

    angular.module('app.common').filter('unsafe', unsafeFunction);

    unsafeFunction.$inject = ['$sce'];

    function unsafeFunction($sce) {
        return function (val) {
            val = val && val.includes('&lt;') ? val.replaceAllString('&lt;','<').replaceAllString('&gt;','>') : val;
            return $sce.trustAsHtml(val);
        };
    }

})();